import type {
  IClassicBuilder,
  IBuilderEdgeConstructorParams,
  IClassicBuilderNode,
} from '#builder';
import {BuilderEdgeTypes} from '#builder';
import {ClassicBuilderEdge} from '#builder/classic_builder/edge.js';
import {audienceBuilderEdgeMap} from '../../../../common/constants/builders/audience_builder.js';

type ChildEdgeConstructorParams = Omit<
  IBuilderEdgeConstructorParams,
  'type'
> & {
  builder?: IClassicBuilder;
};

export interface ChildEdgeMetadata {
  [k: string]: unknown;
}

export type ChildEdgeMetadataMutation = (
  ctx: ChildEdgeMetadata | undefined
) => ChildEdgeMetadata;

export class ChildEdge extends ClassicBuilderEdge<ChildEdgeMetadata> {
  readonly type = BuilderEdgeTypes.CHILD;
  builder?: IClassicBuilder;

  constructor({builder, id, source, target}: ChildEdgeConstructorParams) {
    super({id, source, target, type: BuilderEdgeTypes.CHILD});
    if (builder) this.builder = builder;
  }

  get metadata(): ChildEdgeMetadata {
    return {};
  }

  getSourceNode(): Promise<IClassicBuilderNode | void> {
    if (!this.builder) return Promise.resolve();
    return this.builder.getNode(this.source());
  }

  getTargetNode(): Promise<IClassicBuilderNode | void> {
    if (!this.builder) return Promise.resolve();
    return this.builder.getNode(this.target());
  }

  static createEdgeId(source: string, target: string): string {
    return `${source}:${BuilderEdgeTypes.CHILD}:${target}`;
  }

  static create(
    source: string,
    target: string,
    builder: IClassicBuilder
  ): ChildEdge {
    const id = ChildEdge.createEdgeId(source, target);

    const edge = new ChildEdge({builder, id, source, target});
    return edge;
  }
}

// Add edge class to edge map.
audienceBuilderEdgeMap.set(BuilderEdgeTypes.CHILD, ChildEdge);
